export default __webpack_public_path__ + "static/media/branding-large.54095e59.png";